import styled, { css } from 'styled-components';

const IconWrapper = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  svg {
    width: 24px;
    height: 24px;
  }
  ${(props) =>
    !!props.active &&
    css`
      svg {
        * {
          fill: var(--grey500);
        }
      }
    `}
  ${(props) =>
    !!props.hasWarning &&
    css`
      svg {
        * {
          fill: var(--error-900);
        }
      }
    `}
`;
export default IconWrapper;
